"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var compat_1 = require("preact/compat");
var yotpo_img_1 = require("../../constants/img/yotpo-img");
var YotpoPagination = function (_a) {
    var pagination = _a.pagination, setQueryParams = _a.setQueryParams;
    // Return empty JSX if pagination total is 0 or 1
    if (pagination.total <= 1) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    // Calculate the pagination
    // ref: https://jasonwatmore.com/post/2018/08/07/javascript-pure-pagination-logic-in-vanilla-js-typescript
    var totalPages = Math.ceil(pagination.total / pagination.per_page);
    var maxPages = 7;
    var startPage;
    var endPage;
    if (totalPages <= 7) {
        // total pages less than max so show all pages
        startPage = 1;
        endPage = totalPages;
    }
    else {
        // total pages more than max so calculate start and end pages
        var maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
        var maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
        if (pagination.page <= maxPagesBeforeCurrentPage) {
            // current page near the start
            startPage = 1;
            endPage = maxPages;
        }
        else if (pagination.page + maxPagesAfterCurrentPage >= totalPages) {
            // current page near the end
            startPage = totalPages - maxPages + 1;
            endPage = totalPages;
        }
        else {
            // current page somewhere in the middle
            startPage = pagination.page - maxPagesBeforeCurrentPage;
            endPage = pagination.page + maxPagesAfterCurrentPage;
        }
    }
    // End calculate the pagination
    // Func to go to a target page
    var paginateTo = function (targetPage) {
        var _a;
        // Don't do anything if the target page is the current page
        if (pagination.page == targetPage) {
            return;
        }
        // Scroll animation to review top
        (_a = document.querySelector('#anchor--yotpo-review')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        // Set current query with selected page
        setQueryParams(function (prev) { return (__assign(__assign({}, prev), { page: targetPage })); });
    };
    return ((0, preact_1.h)("div", { class: "yotpo-pagination" },
        (0, preact_1.h)("img", { class: "yotpo-pagination__arrow yotpo-pagination__arrow--left", onClick: function () { return paginateTo(pagination.page - 1); }, src: yotpo_img_1.YOTPO_ARROW, alt: "<" }),
        (0, preact_1.h)("div", { class: "yotpo-pagination__count" }, Array.from(Array(endPage + 1 - startPage).keys()).map(function (i) { return ((0, preact_1.h)("div", { class: "yotpo-pagination__tab ".concat(pagination.page == startPage + i ? 'yotpo-pagination__tab--active' : '', " "), key: "yotpo-pagination__tab--".concat(startPage + i), onClick: function () { return paginateTo(startPage + i); } }, startPage + i)); })),
        (0, preact_1.h)("img", { class: "yotpo-pagination__arrow yotpo-pagination__arrow--right", onClick: function () { return paginateTo(pagination.page + 1); }, src: yotpo_img_1.YOTPO_ARROW, alt: ">" })));
};
exports.default = (0, compat_1.memo)(YotpoPagination);
